import eStonesType from './eStonesType';

export default {
  4: eStonesType.EST_BLUE,
  3: eStonesType.EST_RED,
  2: eStonesType.EST_PURPLE,
  1: eStonesType.EST_GREEN,
  0: eStonesType.EST_YELLOW
}
